<div class="container mt-3 mx-auto">
  <div class="alert alert-info" *ngIf="msgSemResultado">
      Não foram encontradas subscrições com os filtros informados.
  </div>

  <div *ngIf="subscricoes && subscricoes.length">
      <div class="d-flex justify-content-end">
          <button [disabled]="subscricoes.length == 0" class="btn btn-secondary m-0" type="button" (click)="btnExportarSubscricoes()"
          placement="top" ngbTooltip="Exporta as subscrições listadas">
          <i class="fa fa-file"></i> Exportar subscrições</button>
      </div>
      <div class="letra-miuda">atualizado em: {{ dataHoraResultado }}</div>
      <bn-paginacao
          [total]="atributosPaginacao.count"
          [tamanhoPagina]="atributosPaginacao.pageSize" [numPagina]="atributosPaginacao.page"
          [opcoesTamanhoPagina]="opcoesPaginacao" (aoMudar)="mudancaPagina($event)">
          <div class="table-responsive">
              <table class="table table-hover cursor-pointer">
                  <thead>
                      <tr class="text-nowrap">
                          <th id="col-agente" scope="col">
                              <bn-ordenacao
                                  [ordenacao]="atributosOrdenacao"
                                  [atributo]="'cotista.sigla'"
                                  [nomeAtributoExibicao]="'Cotista'"
                                  (aoClickar)="mudancaOrdenacao($event)">
                              </bn-ordenacao>
                          </th>

                          <th id="col-data-inicio" scope="col" class="text-center">
                              <bn-ordenacao
                                  [ordenacao]="atributosOrdenacao"
                                  [atributo]="'categoriaCota'"
                                  [nomeAtributoExibicao]="'Cota'"
                                  (aoClickar)="mudancaOrdenacao($event)">
                              </bn-ordenacao>
                          </th>

                          <th id="col-data-fim" scope="col" class="text-center">
                              <bn-ordenacao
                                  [ordenacao]="atributosOrdenacao"
                                  [atributo]="'numeroCota'"
                                  [nomeAtributoExibicao]="'No. Aporte'"
                                  (aoClickar)="mudancaOrdenacao($event)">
                              </bn-ordenacao>
                          </th>

                          <th id="col-motivo" scope="col" class="text-center">
                              <bn-ordenacao
                                  [ordenacao]="atributosOrdenacao"
                                  [atributo]="'dataSubscricao'"
                                  [nomeAtributoExibicao]="'Data de subscrição'"
                                  (aoClickar)="mudancaOrdenacao($event)">
                              </bn-ordenacao>
                          </th>

                          <th id="col-motivo" scope="col" class="text-end">
                              <bn-ordenacao
                                  [ordenacao]="atributosOrdenacao"
                                  [atributo]="'valor'"
                                  [nomeAtributoExibicao]="'Valor do Aporte'"
                                  (aoClickar)="mudancaOrdenacao($event)">
                              </bn-ordenacao>
                          </th>

                          <th id="col-motivo" scope="col">
                              <bn-ordenacao
                                  [ordenacao]="atributosOrdenacao"
                                  [atributo]="'nomeUsuarioADResponsavel'"
                                  [nomeAtributoExibicao]="'Usuário responsável'"
                                  (aoClickar)="mudancaOrdenacao($event)">
                              </bn-ordenacao>
                          </th>

                          <th id="col-motivo" scope="col" class="text-center">
                              <bn-ordenacao
                                  [ordenacao]="atributosOrdenacao"
                                  [atributo]="'dataAtualizacao'"
                                  [nomeAtributoExibicao]="'Data de Atualização'"
                                  (aoClickar)="mudancaOrdenacao($event)">
                              </bn-ordenacao>
                          </th>
                      </tr>
                  </thead>

                  <tbody>
                      <ng-container *ngFor="let subscricao of subscricoes; let i = index">
                          <tr *ngIf="podeCadastrarSubscricao; else naoPodeCadastrarEditar"
                              [routerLink]="['/habilitacao/subscricao-cota/detalhes', subscricao.cotista?.id, subscricao.cotista?.tipoCotista]"
                              (mouseenter)="hover(i)"
                              (mouseleave)="hoverClean()">
                              <td>{{ subscricao.cotista?.sigla?.toUpperCase() }}</td>
                              <td class="text-center">{{ subscricao.categoriaCota }}</td>
                              <td class="text-center">{{ subscricao.numeroCota | numeroAporte }}</td>
                              <td class="text-center">{{ subscricao.dataSubscricao | date: 'dd/MM/yyyy' }}</td>
                              <td class="text-end">{{ subscricao.valor | bnMask: 'MOEDA' }}</td>
                              <td>{{ subscricao.nomeUsuarioADResponsavel }}</td>
                              <td class="text-center">{{ subscricao.dataAtualizacao | date: 'dd/MM/yyyy HH:mm' }}
                                  <i *ngIf="rowHovered === i" class="fa fa-pen cursor-pointer text-primary ms-4" placement="left-top" ngbTooltip="Editar subscrição"></i>
                              </td>
                          </tr>
                          <ng-template #naoPodeCadastrarEditar>
                              <tr>
                                  <td>{{ subscricao.cotista?.sigla?.toUpperCase() }}</td>
                                  <td>{{ subscricao.categoriaCota }}</td>
                                  <td>{{ subscricao.numeroCota | numeroAporte }}</td>
                                  <td>{{ subscricao.dataSubscricao | date: 'dd/MM/yyyy' }}</td>
                                  <td class="text-end">{{ subscricao.valor | bnMask: 'MOEDA' }}</td>
                                  <td>{{ subscricao.nomeUsuarioADResponsavel }}</td>
                                  <td>{{ subscricao.dataAtualizacao | date: 'dd/MM/yyyy HH:mm' }}</td>
                              </tr>
                          </ng-template>
                      </ng-container>
                  </tbody>

              </table>
          </div>
      </bn-paginacao>
  </div>
</div>
